import ENVIRONMENT from "@/environments/environment";
import { Capacitor } from "@capacitor/core";
import { initTracking } from "@pepper/utm-react";

const loginTrack = (username: string) => {
  initTracking(
    ENVIRONMENT.ENV,
    username.toUpperCase(),
    'merchant',
    'Comercios',
  );
};


const generateLoginTrackingParams = (
  searchParams: URLSearchParams,
) => {
  const utmCampaign = searchParams.get('utm_campaign') ?? 'login_PepperComercios';
  const utmSource = searchParams.get('utm_source') ??  'PepperComercios';
  const utmTrack = searchParams.get('utm_track');
  const utmVariant = searchParams.get('utm_variant') ?? 'Control';
  let utmMedium = searchParams.get('utm_medium') ?? 'WEB';
  let utmContent = searchParams.get('utm_content') ?? '';
  let utmTerm = searchParams.get('utm_term') ?? '';
  const pClientType = 'lead';

  if (Capacitor.getPlatform() !== 'web') {
    utmMedium = 'APP';
  }

  return `?utm_campaign=${utmCampaign}&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${utmContent}&pclient_type=${pClientType}&utm_track=${utmTrack}&utm_variant=${utmVariant}&utm_term=${utmTerm}`;
};

export {
  generateLoginTrackingParams,
  loginTrack,
};
